import { ChainId, FactoryVersion } from '@nominex/nomiswap-sdk'
import { tokens } from 'config/tokens'
import { serializeFarm } from './helpers'
import { SerializedFarmConfig } from './types'

// Farm pid should start from chain id

const farms: SerializedFarmConfig[] = [
  {
    pid: 137201,
    token: tokens[ChainId.MATIC].usdc,
    quoteToken: tokens[ChainId.MATIC].usdt,
    earningToken: tokens[ChainId.MATIC].nmx,
    lpAddress: '0xC878f03372852Bd04b3734a43d23bDEE534dCd33',
    stakingServiceAddress: '0x42e274943f843762C980812045E38e59CB274305',
    finished: true,
    version: FactoryVersion.V2,
  },
].map(serializeFarm)

export default farms
